import { TextField, TextFieldProps } from '@mui/material';
import { CompositionEventHandler, FC } from 'react';

const beforeInputHandler: CompositionEventHandler<HTMLInputElement> = e => {
  if (!/^\d+$/.test(e.data)) e.preventDefault();
};

export const IntegerTextField: FC<TextFieldProps> = props => (
  <TextField {...props} type="number" onBeforeInput={beforeInputHandler} />
);
